<template>
  <div class="page">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>

    <div class="big-center">
      <!-- 项目介绍 -->
      <p class="every-title">项目介绍</p>
      <div class="project-intro-content">
        <img
          class="imgae-box"
          v-complete:src="mydata.project_profile_image"
          alt=""
        />
        <p v-html="mydata.project_profile_text"></p>
      </div>

      <!-- 活动回放 -->
      <p class="every-title">活动回放</p>
      <el-scrollbar height="636px" v-if="mydata.articleListArr.length > 2">
        <div class="activity-replay-content">
          <div
            class="activity-cards"
            v-for="(item, index) in mydata.articleListArr"
            :key="index"
          >
            <img
              class="activity-image"
              @click="handleQrClick(item)"
              v-complete:src="item.image"
              alt=""
            />

            <p>讲座专题：{{ item.title }}</p>
            <p>讲座专家：{{ item.participant }}</p>
            <p>讲座学科：{{ byIdGetText(item.subject, "subject") }}</p>

            <el-button type="primary" round @click="handleQrClick(item)"
              >观看回放</el-button
            >
          </div>
        </div>
      </el-scrollbar>
      <div class="activity-replay-content" v-else>
        <div
          class="activity-cards"
          v-for="(item, index) in mydata.articleListArr"
          :key="index"
        >
          <img
            class="activity-image"
            @click="handleQrClick(item)"
            v-complete:src="item.image"
            alt=""
          />

          <p>讲座专题：{{ item.title }}</p>
          <p>讲座专家：{{ item.participant }}</p>
          <p>讲座学科：{{ byIdGetText(item.subject, "subject") }}</p>

          <el-button type="primary" round @click="handleQrClick(item)"
            >观看回放</el-button
          >
        </div>
      </div>

      <!-- 支持单位 -->
      <p class="every-title support-unit-title">支持单位</p>
      <div class="support-unit-content">
        <!-- 词云 -->
        <!-- <EchartsCustom
          :width="mydata.support_unit_echarts.echartW"
          :option="mydata.supportUnitOption"
        /> -->
        <img v-complete:src="mydata.support_unit_image" alt="" />
      </div>
    </div>

    <!-- 视频弹窗 -->
    <el-dialog
      v-if="centerDialogVisible"
      v-model="centerDialogVisible"
      width="343px"
      align-center
    >
      <template #header>
        <p class="my-header">
          视频播放
          <span class="play-number"
            >（{{ mydata.item_obj.play_number }}人已观看）</span
          >
        </p>
      </template>
      <div style="margin: 0px auto; display: flex; justify-content: center">
        <myXgplayer
          @videoPlay="PlayNumber"
          :width="mydata.video.width"
          :height="mydata.video.height"
          :url="completeUrl(mydata.item_obj.video_url)"
        ></myXgplayer>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
// import * as echarts from "echarts";
import { ElMessage, ElMessageBox } from "element-plus";
// import "echarts-wordcloud";
import EchartsCustom from "@/components/EchartsCustom/index.vue";

import imgBigCards from "@/components/imgBigCards/index.vue";
//视频
import myXgplayer from "@/components/myXgplayer/index.vue";

import { completeUrl } from "@/utils/utils.js";

// 引入接口
import { articleList } from "@/api/home/index.js";
// 引入接口
import { getUrlId } from "@/utils/slide.js";

import { reactive, toRaw, ref } from "vue";
import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue";

import { useRouter, useRoute } from "vue-router";

//swiper start//////////////////////////////////////////////////////////////////////////////////////////////
// 引入swiper插件
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/modules";

// 引入接口
import { specialSubjectConfig } from "@/api/fundingPublicWelfareProjects/index.js";

// 引入接口
import { articlePlayNumber } from "@/api/studentWorld/index.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
  // 项目介绍
  xxx: "",
  // 词云
  // support_unit_echarts: {
  //   echartW: "1200px",
  //   // echartH: "100%",
  // },
  //视频
  video: {
    width: "343px",
    height: "201px",
  },

  // 图片基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

  project_profile_image: "", //项目介绍图
  project_profile_text: "", //项目介绍文字
  support_unit_image: "", //支持单位图

  form: {
    column_id: getUrlId(route.path), // 栏目id值
    // search: "", // 搜索查询
  },
  articleListArr: [], // 文章列表
  item_obj: {},
  subject: JSON.parse(localStorage.getItem("subject")) ?? [],
  number: false,
  // 词云
  // supportUnitOption: {
  //   series: [
  //     {
  //       type: "wordCloud", // 指定词云类型
  //       shape: "circle", // 形状：circle/cardioid/diamond 等
  //       sizeRange: [12, 60], // 字体大小范围
  //       rotationRange: [-45, 45], // 旋转角度范围
  //       gridSize: 8, // 词间距
  //       textStyle: {
  //         color: () =>
  //           `rgb(${Math.random() * 255}, ${Math.random() * 255}, ${
  //             Math.random() * 255
  //           })`,
  //       },
  //       data: [
  //         // 词云数据：name为词，value为权重
  //         { name: "可视化", value: 95 },
  //         { name: "ECharts", value: 85 },
  //         { name: "词云", value: 70 },
  //         { name: "天利38套考试研究网", value: 100 },
  //         { name: "中国", value: 80 },
  //         { name: "北京", value: 90 },
  //         // 更多数据...
  //       ],
  //     },
  //   ],
  // },
});

// 通过ID得到对应文字
function byIdGetText(id, key) {
  // console.log(mydata[key],"111")
  return mydata[key].find((item) => String(item.name) === String(id))?.label;
}

// 视频弹窗
const centerDialogVisible = ref(false);

// // 视频弹窗点击事件
// function handleQrClick(item) {
//   // 显示弹窗
//   centerDialogVisible.value = true;
//   mydata.item_obj = item;
//   // console.log(url)
// }

///判断是否登录
function handleQrClick(item) {
  //如果登录了，就正常打开视频弹窗；否则，弹窗提醒未登录，然后跳转到登录页面
  if (mydata.userInfo.jwt) {
    centerDialogVisible.value = true;
    mydata.item_obj = item;
  } else {
    // 弹窗提醒未登录
    ElMessage({
      message: "当前用户未登录",
      type: "error",
    });
    // 跳转到登录页面
    router.push({
      path: "/login/nowLogin",
    });
  }
}

// 视频播放量
function PlayNumber() {
  if (!mydata.number) {
    articlePlayNumber({
      id: mydata.item_obj.id,
    }).then((res) => {
      // console.log(res.data, "接口成功了");
    });
  }
  mydata.number = true;
}

// 专题接口
function specialSubjectConfigFn() {
  specialSubjectConfig({}).then((res) => {
    mydata.project_profile_image = res.data.special_subject_image.value; //项目介绍图片
    mydata.project_profile_text = res.data.special_subject_text.value; //项目介绍文字
    mydata.support_unit_image = res.data.special_subject_cloud_image.value; //支持单位
  });
}
specialSubjectConfigFn();

// 获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
  }).then((res) => {
    // 文章列表
    // console.log( res.data.list);
    mydata.articleListArr = res.data.list;
  });
}

articleListFn();
</script>

<style scoped lang="scss">
.page {
  padding-bottom: 24px;
  // border:1px solid red;
  // background-color: #f7fcfc;

  //标题
  .every-title {
    width: 343px;
    font-size: 18px;
    font-weight: 700;
    line-height: 32px;
    color: #333333;
    margin: 0 auto;
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .big-center {
    // width: 375px;
    // border: 1px solid rgb(30, 255, 0);
    margin: 0 auto;
    // .every-title {
    //   margin-bottom: 0px;
    // }

    //项目介绍
    .project-intro-content {
      width: 343px;
      margin: 0 auto;
      // border: 1px solid rgb(43, 31, 212);
      // display: flex;
      // align-items: center;
      .imgae-box {
        width: 343px;
        display: block;
      }
      > p {
        width: 343px;
        text-indent: 2em;
        line-height: 20px;
        font-size: 15px;
        margin-top: 10px;
        font-weight: 400;
        color: #333333;
        // border:1px solid red;
        // text-align: justify;

        // display: -webkit-box;
        // -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        // text-overflow: ellipsis; //文本溢出 用省略号显示
        // -webkit-line-clamp: 10; //几行
        // overflow: hidden;
      }
      // > img {
      //   display: block;
      //   width: 590px;
      //   height: 245px;
      //   border:1px solid red;
      // }
    }

    //活动回放
    .activity-replay-content {
      width: 343px;
      margin: 0 auto;
      // display: flex;
      // flex-wrap: wrap;
      // box-sizing: border-box;
      // border: 1px solid pink;

      .activity-cards {
        width: 343px;
        padding: 16px;
        border-radius: 24px;
        background-color: #fff;
        box-shadow: 0px 0px 13.9px 0px #ccebeb4d;
        position: relative;
        flex-shrink: 1;
        // margin-right: 10px;
        margin-bottom: 16px;
        .activity-image {
          width: 311px;
          height: 193px;
          margin-bottom: 6px;
          display: block;
          cursor: pointer;
        }
        > p {
          color: #333;
          font-size: 15px;
          line-height: 26px;
          white-space: nowrap; //不折行
          text-overflow: ellipsis; //文本溢出 用省略号显示
          overflow: hidden;
        }

        :deep(.el-button.el-button--primary.is-round) {
          width: 82px;
          height: 28px;
          position: absolute;
          bottom: 16px;
          right: 16px;
        }
      }

      .activity-cards:nth-of-type(4n) {
        margin-right: 0px;
      }
    }

    //支持单位
    .support-unit-title {
      margin-top: 24px;
    }
    //支持单位
    .support-unit-content {
      width: 343px;
      margin: 0 auto;
      display: block;
      border-radius: 12px;
      //background-color: #fff;
      box-shadow: 0px 0px 13.9px 0px #ccebeb4d;

      // border: 1px solid red;
      > img {
        width: 100%;
        border-radius: 12px;
      }
    }
  }
}

//视频组件
// :deep(#video-box) {
//   border-radius: 10px;
// }
// 弹窗
:deep(.el-dialog.is-align-center) {
  padding: 0px !important;
  // border:1px solid blue !important;
  border-radius: 4px;
  .my-header {
    font-size: 16px;
  }
  .play-number {
    font-size: 14px;
    color: #333;
    // margin-left: 10px;
  }

  .el-dialog__header.show-close {
    height: 36px;
    line-height: 36px;
    padding: 0px 32px 0px 16px;
  }
  .el-dialog__body {
    margin: 0px;
  }
}
//
:deep(.xgplayer-fullscreen) {
  display: none;
}

:deep(.xgplayer-cssfullscreen) {
  display: none;
}

:deep(.el-dialog__headerbtn) {
  width: 36px;
  height: 36px;
}
</style>
